export default {
    methods: {
        listAdd(list) {
            let _ = {}
            Object.keys(list[0]).map(key => {
                _[key] = undefined
            })
            list.push(_)
        },
        listReset(list) {
            Object.keys(list[0]).map(key => {
                list[0][key] = undefined
            })
        },
        listRemove(list, item) {
            const index = list.indexOf(item);
            if (index !== -1) {
                list.splice(index, 1)
            }
        },
    },
}